import { updateIncidentCategorizationUseCase } from '@src/main/modules/other_incidents/application/use-cases/update/update-incident-categorization.usecase';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useUpdateIncidentCategorization = () => {
  const queryClient = useQueryClient();
  const { user } = useAuth();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  return useMutation({
    mutationFn: async ({ id, categorization }: { id: string; categorization: string }) =>
      await updateIncidentCategorizationUseCase(
        {
          id,
          categorization,
        },
        tokenProvider,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['incidents'] });
    },
  });
};
